import type * as React from "react";

import { type ControlSize, controlVariants } from "./control-variants";
import { cn } from "./utils";

type TextareaProps = React.ComponentProps<"textarea"> & {
  controlSize?: ControlSize;
};

function Textarea({ className, controlSize, ...props }: TextareaProps) {
  return (
    <textarea
      className={cn(
        controlVariants({ size: controlSize }),
        "field-sizing-content flex min-h-16 resize-none px-3 py-2 text-base md:text-sm",
        className,
      )}
      data-slot="textarea"
      {...props}
    />
  );
}

export { Textarea };
